import type { FormValues } from "../form";

export const getHistoryFormValues = (): FormValues | undefined =>
    window.history.state?.formValues as FormValues | undefined;

export const isBackForwardNavigation = (): boolean => {
    const entry = performance.getEntriesByType("navigation")[0] as PerformanceNavigationTiming | undefined;
    return entry?.type === "back_forward";
};

export const preserveFormStateInCache = (formValues: FormValues): void => {
    window.history.replaceState({ formValues }, "");
};
